import React, { useCallback, useEffect, useState } from 'react';
import { Navigate, Route, Routes, useNavigate, useParams } from 'react-router-dom';

function RedirectToPropietarios() {
  const { cid } = useParams();
  return <Navigate to={`/c/${cid}/propietarios`} replace />;
}

function RedirectToUsuarios() {
  const { cid } = useParams();
  return <Navigate to={`/c/${cid}/usuarios`} replace />;
}

function RedirectToCobranza() {
  const { cid } = useParams();
  return <Navigate to={`/c/${cid}/cobranza`} replace />;
}
import { fetchGcMe, login, logout } from './api';
import LoginPage from './pages/LoginPage';
import SelectCondominioPage from './pages/SelectCondominioPage';
import Layout from './components/Layout';
import PropietariosPage from './pages/PropietariosPage';
import ImportarPage from './pages/ImportarPage';
import UsuariosInvitacionesPage from './pages/UsuariosInvitacionesPage';
import PeriodosPage from './pages/PeriodosPage';
import ConfigCondominioPage from './pages/ConfigCondominioPage';
import SuperAdminPage from './pages/SuperAdminPage';
import InvitacionPage from './pages/InvitacionPage';
import DashboardPage from './pages/DashboardPage';
import CobrosPage from './pages/CobrosPage';
import CobranzaMesPage from './pages/CobranzaMesPage';
import CobranzaHistorialPage from './pages/CobranzaHistorialPage';
import CobranzaHistorialDetallePage from './pages/CobranzaHistorialDetallePage';
import PagosPage from './pages/PagosPage';
import EgresosPage from './pages/EgresosPage';
import FlujoCajaPage from './pages/FlujoCajaPage';
import CorreosPage from './pages/CorreosPage';
import InformesCierrePage from './pages/InformesCierrePage';
import PortalPage from './pages/PortalPage';

function App() {
  const [gcMe, setGcMe] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const refreshMe = useCallback(async () => {
    const token = localStorage.getItem('gc_token');
    if (!token) {
      setGcMe(null);
      setLoading(false);
      return;
    }
    try {
      const me = await fetchGcMe();
      setGcMe(me);
    } catch {
      logout();
      setGcMe(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refreshMe();
  }, [refreshMe]);

  const handleLogin = async (email, password) => {
    await login(email, password);
    setLoading(true);
    await refreshMe();
    navigate('/condominios');
  };

  const handleLogout = () => {
    logout();
    setGcMe(null);
    navigate('/login');
  };

  if (loading) {
    return <div className="loading-screen">Cargando…</div>;
  }

  const authed = Boolean(gcMe);

  return (
    <Routes>
      <Route path="/invitacion" element={<InvitacionPage onAccepted={refreshMe} />} />
      <Route
        path="/login"
        element={authed ? <Navigate to="/condominios" replace /> : <LoginPage onLogin={handleLogin} />}
      />
      <Route
        path="/*"
        element={
          !authed ? (
            <Navigate to="/login" replace />
          ) : (
            <Layout gcMe={gcMe} onLogout={handleLogout}>
              <Routes>
                <Route path="/condominios" element={<SelectCondominioPage gcMe={gcMe} />} />
                <Route path="/admin" element={<SuperAdminPage gcMe={gcMe} />} />
                <Route path="/c/:cid" element={<DashboardPage />} />
                <Route path="/c/:cid/cobros" element={<CobrosPage />} />
                <Route path="/c/:cid/cobranza/historial/:periodo" element={<CobranzaHistorialDetallePage />} />
                <Route path="/c/:cid/cobranza/historial" element={<CobranzaHistorialPage />} />
                <Route path="/c/:cid/cobranza" element={<CobranzaMesPage />} />
                <Route path="/c/:cid/ingresos" element={<RedirectToCobranza />} />
                <Route path="/c/:cid/pagos" element={<RedirectToCobranza />} />
                <Route path="/c/:cid/cobros" element={<RedirectToCobranza />} />
                <Route path="/c/:cid/egresos" element={<EgresosPage />} />
                <Route path="/c/:cid/flujo-caja" element={<FlujoCajaPage />} />
                <Route path="/c/:cid/correos" element={<CorreosPage />} />
                <Route path="/c/:cid/informes" element={<InformesCierrePage />} />
                <Route path="/c/:cid/portal" element={<PortalPage />} />
                <Route path="/c/:cid/propietarios" element={<PropietariosPage />} />
                <Route path="/c/:cid/unidades" element={<RedirectToPropietarios />} />
                <Route path="/c/:cid/importar" element={<ImportarPage />} />
                <Route path="/c/:cid/usuarios" element={<UsuariosInvitacionesPage />} />
                <Route path="/c/:cid/periodos" element={<PeriodosPage />} />
                <Route path="/c/:cid/config" element={<ConfigCondominioPage />} />
                <Route path="/c/:cid/invitar" element={<RedirectToUsuarios />} />
                <Route path="/" element={<Navigate to="/condominios" replace />} />
              </Routes>
            </Layout>
          )
        }
      />
    </Routes>
  );
}

export default App;
